import i18n, { CallbackError, ReadCallback } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { TranslationNamespace } from '../types';
import { ContentfulEntry } from '../types';
import { SUPPORTED_LANGUAGES } from '../utils';
import {
  getContentfulTranslationsOnReadFailure,
  isContentfulNamespace,
  mapContentfulEntries,
} from './contentfulI18nBackend';

class CustomBackend extends Backend {
  async read(language: string, namespace: string, callback: ReadCallback) {
    if (!SUPPORTED_LANGUAGES[language]) {
      language = 'en';
    }
    try {
      if (namespace === TranslationNamespace.LEP) {
        const response = await fetch(`/locales/${language}/lep.json`);
        const translations = await response.json();
        callback(null, translations);
      }  else if (namespace === TranslationNamespace.CONTENTFUL) {
        const response = await fetch(`/api/contentful?locale=${language}`);
        const contentfulEntries: ContentfulEntry[] = await response.json();

        callback(null, mapContentfulEntries(contentfulEntries));
      }
    } catch (error) {
      if (isContentfulNamespace(namespace)) {
        callback(null, getContentfulTranslationsOnReadFailure());
        return;
      }
      callback(error as CallbackError, null);
    }
  }
}

i18n
  .use(new CustomBackend())
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
    nonExplicitSupportedLngs: true,
    ns: Object.values(TranslationNamespace),
    defaultNS: TranslationNamespace.LEP,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
